var Marionette = require('backbone.marionette');
var Radio = require('backbone.radio');
var notificationsChannel = Radio.channel('notifications');

var AuthByInstantToken = Marionette.View.extend({
    template: require('../../templates/persons/login.html'),

    initialize: function(options){
        this.token = options.token;
        _.bindAll(this, 'performLogin');
    },
    onRender: function () {
        this.performLogin();
    },
    performLogin: function(){
        $.ajax({
            type: "GET",
            url: '/api/login/auth/instant/token/' + this.token,
            statusCode: {
                200: function() {
                    Backbone.history.navigate('/documents?toReview=true&simpleMode=true', {trigger: true});
                }
            },
            error: function (e) {
                notificationsChannel.request('show:notification', e.responseJSON);
                Backbone.history.navigate('/', {trigger: true});
            }
        });
    },
});

module.exports = AuthByInstantToken;


//////////////////
// WEBPACK FOOTER
// ./app/views/persons/auth-by-instant-token.js
// module id = 513
// module chunks = 0